<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-01 09:43:39
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-12-19 16:27:02
 * @FilePath: \minipro-manger\src\views\WeatherAlert\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE   
-->
<template>
  <div>
    <el-card class="box-card" style="height:850px">
      <div slot="header">
        <div class="headerCardBox">
          <div style="display:flex;  align-items: center;">
            <div style="margin-left:50px;width:120px">类型：</div>
            <div style="width:500px;  display: flex;">
              <el-select v-model="type" placeholder="请选择">
                <el-option
                  v-for="item in typelist"
                  :key="item.name"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>

          <!-- <div style="margin-left:50px;width:120px">发布时间：</div>
          <div style="width:600px;  display: flex;">
            <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>-->
          <div style="width:300px">
            <el-input placeholder="请输入内容" v-model="input1">
              <template slot="prepend">状态：</template>
            </el-input>
          </div>
        </div>
        <div class="seachBtn">
          <el-button type="primary" @click="getTableData">搜索</el-button>
          <el-button type="primary">重置</el-button>
        </div>
      </div>
      <div>
        <div class="adddBtnBox">
          <el-button @click="addNew">添加</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%" :border="true" height="600">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="name" label="标题"></el-table-column>
          <el-table-column prop="type" label="类型">
            <template slot-scope="scope">
              <div>{{getTypeName(scope.row.type)}}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="path" label="路径"></el-table-column> -->
          <el-table-column prop="url" label="地址"></el-table-column>
          <!-- <el-table-column prop="address" label="创建时间"></el-table-column>
          <el-table-column prop="address" label="审核时间"></el-table-column>
          <el-table-column prop="address" label="状态"></el-table-column>-->
          <el-table-column prop="address" label="操作" width="200">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.row)">修改</el-button>

              <el-popconfirm title="这是一段内容确定删除吗？" @confirm="delList(scope.row.id)">
                <el-button size="mini" type="danger" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination> -->
    </el-card>
    <el-dialog title="信息修改" :visible.sync="isShowEditPop" width="30%">
      <div class="myinputBox">
        <div style="width:10%">类型：</div>
        <div style="width:90%">
          <el-select v-model="EditFrom.type" placeholder="请选择" style="width:100%">
            <el-option
              v-for="item in typelist2"
              :key="item.name"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="myinputBox">
        <div style="width:10%">名称：</div>
        <div style="width:90%">
          <el-input placeholder="请输入内容" v-model="EditFrom.name" clearable></el-input>
        </div>
      </div>
      <div class="myinputBox">
        <div style="width:10%">地址：</div>
        <div style="width:90%">
          <el-input placeholder="请输入内容" v-model="EditFrom.url" clearable></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editCan">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="信息修改" :visible.sync="isShowAddPop" width="30%">
      <div class="myinputBox">
        <div style="width:10%">类型：</div>
        <div style="width:90%">
          <el-select v-model="addfromData.type" placeholder="请选择" style="width:100%">
            <el-option
              v-for="item in typelist2"
              :key="item.name"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="myinputBox">
        <div style="width:10%">名称：</div>
        <div style="width:90%">
          <el-input placeholder="请输入内容" v-model="addfromData.name" clearable></el-input>
        </div>
      </div>
      <div class="myinputBox">
        <div style="width:10%">地址：</div>
        <div style="width:90%">
          <el-input placeholder="请输入内容" v-model="addfromData.url" clearable></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowAddPop=false">取 消</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      newtableData: [],
      input1: "",
      type: "qxkp",
      typelist: [
        {
          name: "全部",
          value: "qxkp"
        },
        {
          name: "农气说",
          value: "qxkp_NongQiShuo"
        },
        {
          name: "气象科普",
          value: "qxkp_QiXiangKePu"
        },
        {
          name: "应急科普",
          value: "qxkp_YingJiKePu"
        }
      ],
      typelist2: [
        {
          name: "农气说",
          value: "qxkp_NongQiShuo"
        },
        {
          name: "气象科普",
          value: "qxkp_QiXiangKePu"
        },
        {
          name: "应急科普",
          value: "qxkp_YingJiKePu"
        }
      ],
      value1: "",
      editData: {},
      isShowEditPop: false,
      isShowAddPop: false,
      addfromData: {
        type: "",
        name: "",
        url: ""
      },

      EditFrom: {
        name: "",
        type: "",
        url: "",
        id: ""
      }
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    delList(id) {
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/fileUrl/deleteInfo",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          id: id
        }
      }).then(res => {
        // console.log(res);
        this.$message({
          message: "删除成功",
          type: "success"
        });
        this.getTableData();
      });
    },
    submitAdd() {
      console.log(this.addfromData);
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/fileUrl/saveUrlInfo",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          type: this.addfromData.type,
          name: this.addfromData.name,
          url: this.addfromData.url,
          path: null
        }
      }).then(res => {
        // console.log(res);
        this.$message({
          message: "新增成功",
          type: "success"
        });
        this.isShowAddPop = false;
        this.getTableData();
      });
    },
    addNew() {
      this.isShowAddPop = true;
      this.addfromData = {
        type: "",
        name: "",
        url: ""
      };
    },
    handleEdit(data) {
      this.editData = data;
      this.EditFrom.name = this.editData.name || "";
      this.EditFrom.type = this.editData.type;
      this.EditFrom.url = this.editData.url;
      this.EditFrom.id = this.editData.id;
      console.log(this.EditFrom);
      this.isShowEditPop = true;
    },
    getTypeName(data) {
      let myname = this.typelist.find(item => {
        return item.value == data;
      });
      return myname.name;
    },
    submitEdit() {
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/fileUrl/updateInfo",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          type: this.EditFrom.type,
          name: this.EditFrom.name,
          url: this.EditFrom.url,
          id: this.EditFrom.id
        }
      }).then(res => {
        // console.log(res);
        this.$message({
          message: "修改成功",
          type: "success"
        });
        this.isShowEditPop = false;
        this.getTableData();
      });
    },
    editCan() {
      this.dialogVisible = false;
      this.EditFrom = {
        name: "",
        type: "",
        url: ""
      };
    },
    typeChange(e) {
      console.log(e, this.tableData);
      if (e == "全部") {
        this.newtableData = this.tableData;
      } else {
        this.newtableData = this.tableData.filter(item => {
          return item.type == e;
        });
      }
    },
    getTableData() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/fileUrl/getFileUrlInfo",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          type: this.type
        }
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data;
        loading.close();
        // let arrMap = [];
        // this.newtableData = this.tableData;
        // this.tableData.map(item => {
        //   arrMap.push(item.type);
        // });
        // console.log(arrMap);
        // // console.log();
        // this.typelist = Array.from(new Set(arrMap));
        // this.typelist.push("全部");
        // this.allData = res.data;
      });
    }
  }
};
</script>

<style>
.headerCardBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.seachBtn {
  display: flex;
  justify-content: end;
  margin-top: 15px;
}
.adddBtnBox {
  height: 50px;
  float: right;
}
.myinputBox {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
</style>